export const readEmbedParams = (search: string) => {
  const params = new URLSearchParams(search);
  return {
    file: params.get("file"),
    lang: params.get("lang"),
  };
};

export const postCutoutResult = (dataUrl: string) => {
  window.parent.postMessage({ message: dataUrl }, "*");
};
